var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showContent
        ? _c(
            "el-dialog",
            {
              staticClass: "main-info",
              attrs: {
                "show-close": false,
                visible: _vm.visible,
                "destroy-on-close": "",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.visible = $event
                }
              }
            },
            [
              _c("p", [
                _c(
                  "span",
                  {
                    staticClass: "back_icon",
                    on: {
                      click: function($event) {
                        _vm.visible = false
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-arrow-left" }),
                    _vm._v("Back")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("Are you satisfied with the brand/product?")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-info", on: { click: _vm.clickBrand } },
                [
                  _c("div", [
                    _c("img", { attrs: { src: _vm.brandInfo["brandLogoUrl"] } })
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.orderInfo["brandName"]))])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sub-content" },
                [
                  _c("div", { staticClass: "rating-content" }, [
                    _c(
                      "p",
                      { staticClass: "rating" },
                      [
                        _c("span", [_vm._v("Product Quality")]),
                        _vm._v(" "),
                        _c("el-rate", {
                          staticClass: "cust-rating",
                          attrs: {
                            "void-color": "#000",
                            "void-icon-class": "el-icon-star-off",
                            "show-text": true,
                            texts: _vm.disTxtRatings,
                            colors: _vm.colors
                          },
                          model: {
                            value: _vm.form["descriptionRating"],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "descriptionRating", $$v)
                            },
                            expression: "form['descriptionRating']"
                          }
                        }),
                        _vm._v(" "),
                        _vm.vail["descriptionRating"]
                          ? _c("span", [_vm._v("Please rate")])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "rating" },
                      [
                        _c("span", [_vm._v("Brand Service")]),
                        _vm._v(" "),
                        _c("el-rate", {
                          staticClass: "cust-rating",
                          attrs: {
                            "void-color": "#000",
                            "void-icon-class": "el-icon-star-off",
                            "show-text": true,
                            texts: _vm.disTxtRatings,
                            colors: _vm.colors
                          },
                          model: {
                            value: _vm.form["serviceRating"],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "serviceRating", $$v)
                            },
                            expression: "form['serviceRating']"
                          }
                        }),
                        _vm._v(" "),
                        _vm.vail["serviceRating"]
                          ? _c("span", [_vm._v("Please rate")])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "rating" },
                      [
                        _c("span", [_vm._v("Logistics Rating")]),
                        _vm._v(" "),
                        _c("el-rate", {
                          staticClass: "cust-rating",
                          attrs: {
                            "void-color": "#000",
                            "void-icon-class": "el-icon-star-off",
                            "show-text": true,
                            texts: _vm.disTxtRatings,
                            colors: _vm.colors
                          },
                          model: {
                            value: _vm.form["logisticsRating"],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "logisticsRating", $$v)
                            },
                            expression: "form['logisticsRating']"
                          }
                        }),
                        _vm._v(" "),
                        _vm.vail["logisticsRating"]
                          ? _c("span", [_vm._v("Please rate")])
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "add-review" }, [
                    _vm._v("Add review")
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "add-review-textarea" },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            type: "textarea",
                            "show-word-limit": "",
                            placeholder:
                              "Are you satisfied with the product? Can describe problems and help Brand improve",
                            rows: "5",
                            maxlength: "1000",
                            oninput:
                              "if(value.length>1000)value=value.slice(0,1000)"
                          },
                          model: {
                            value: _vm.form["reviewContent"],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "reviewContent", $$v)
                            },
                            expression: "form['reviewContent']"
                          }
                        },
                        [_vm._v("\n         >")]
                      ),
                      _vm._v(" "),
                      _vm.vail["reviewContent"]
                        ? _c("span", [_vm._v("Please enter the review")])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "add-photo" }, [
                    _vm._v("Add a photo or video")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "add-photo-subtitle" }, [
                    _vm._v(
                      "Shoppers find images and videos more helpful than text alone."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        action: _vm.uploadApi,
                        "list-type": "picture-card",
                        accept: ".jpeg,.png,.jpg",
                        headers: _vm.headers,
                        limit: 30,
                        "file-list": _vm.filelist,
                        "on-remove": _vm.handleRemove,
                        "on-success": _vm.handleSuccess,
                        "on-exceed": _vm.handleExceed
                      },
                      on: {
                        "update:fileList": function($event) {
                          _vm.filelist = $event
                        },
                        "update:file-list": function($event) {
                          _vm.filelist = $event
                        }
                      }
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("div", { staticClass: "img-list" }, [
                    _c(
                      "div",
                      { ref: "orderImgRef" },
                      _vm._l(_vm.imgList, function(itm, i) {
                        return _c("img", { attrs: { src: itm } })
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "more-img",
                        on: { click: _vm.clickOrder }
                      },
                      [
                        _vm.showMore
                          ? _c("span", [_vm._v(_vm._s(_vm.totalOrderImgCnt))])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("i", { staticClass: "el-icon-arrow-right" })
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "submit", on: { click: _vm.submit } }, [
                _vm._v("Submit")
              ])
            ]
          )
        : _c(
            "el-dialog",
            {
              staticClass: "success-info",
              attrs: {
                "show-close": false,
                visible: _vm.visible,
                "destroy-on-close": "",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.visible = $event
                }
              }
            },
            [
              _c("p", [
                _c(
                  "span",
                  {
                    staticClass: "back_icon",
                    on: {
                      click: function($event) {
                        _vm.visible = false
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-arrow-left" }),
                    _vm._v("Back")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "review-success" }, [
                _c("div"),
                _vm._v(" "),
                _c("p", [_vm._v("Thanks for your review !")])
              ])
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c7a415c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c7a415c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/order-review.vue
// module id = null
// module chunks = 